<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { mapState } from "vuex";
import { PRODUCT_PRINTER_PROOF_MODULE } from '@/state/modules/productPrinterProof'
import { productPrinterProofMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.printerProof')]),
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'Product-printer-proof-update' && to.name != 'Product-printer-proof-create') {
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH)
        }
        next();
    },
    async created() {
        await this.validPermissions();
        this.initSearchCriteria();
    },
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: i18n.t("label.listingX", [i18n.t('module.printerProof')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.printerProof"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            accountLockStatusDdl: ddlHelper.getAccountLockStatus(true),
            currentUser: sessionHelper.getUserEmail(),
            currentPage: 1,
            filter: "",
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            updatePermission: null,
            updateStatusPermission: null,
            readPermission: null,
            enabled: false,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            pageOptions: [10, 25, 50, 100],
            filterOn: [],
            sortBy: "name",
            fields: [
                { key: "product", sortable: true, label: i18n.t("module.product"), },
                { key: "type", sortable: true, label: i18n.t("label.type") },
                { key: "date", sortable: true, label: i18n.t("label.date") },
                { key: "isActive", sortable: true, label: i18n.t("label.recordStatus") },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
        };
    },
    computed: {
        ...mapState(PRODUCT_PRINTER_PROOF_MODULE, ['status']),
        tableRows() {
            return this.$store.state.productPrinterProof.list.data;
        },
        pagination() {
            return this.$store.state.productPrinterProof.list.pagination;
        },
        totalPage() {
            return this.$store.state.productPrinterProof.list.pagination.total;
        },
    },
    mounted() { },
    methods: {
        ...productPrinterProofMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPR")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }
        },
        initSearchCriteria() {
            let isDefault = true;

            if (sessionHelper.hasSearchCriteria(SESSION.PRODUCT_PRINTER_PROOF_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
                this.filter = this.searchCriteria.searchArray[0];
                this.isActive = ddlHelper.getActivationStatus(true).find(item => item.value === this.searchCriteria.isActive);
            }

            if (isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.statusDdl[1].value,
                    isLocked: this.accountLockStatusDdl[0].value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            if (this.readPermission == true) {
                this.getPrinterList(this.searchCriteria);
            }
        },

        getPrinterList(filter) {
            this.getAllProductPrinterProofs({ filter });
            // this.$store.dispatch(`user/getAllUser`, { filter });
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH, filter);
        },

        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            filter.pageNumber = pageNumber;

            this.getPrinterList(filter);
        },

        toDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH)
            filter.selectedRecordId = id
            sessionHelper.storeSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH, filter)

            this.$router.push({
                name: 'Product-printer-proof-update', // Name of the route
            });
        },


        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getPrinterList(this.searchCriteria);
        },

        editStatus(user) {
            const data = {
                id: user.uuid,
                isActive: user.isActive,
            };

            this.updateProductPrinterProofStatus({ filter: this.searchCriteria, data });
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                    style="float: left">
                                    <label class="d-inline-flex align-items-center">
                                        {{ $t("label.search") }}
                                        <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                                            class="form-control form-control-sm ml-2"
                                            @change="searchListing"></b-form-input>
                                    </label>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="row d-flex justify-content-end">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-4 col-9 mb-2">
                                        <multiselect
                                            v-model="isActive"
                                            deselect-label=""
                                            track-by="value"
                                            label="text"
                                            :placeholder="$t('module.status')"
                                            :options="statusDdl"
                                            :searchable="true"
                                            :allow-empty="false"
                                            v-on:input="searchListing"
                                        ></multiselect>
                                    </div>
                                    <div class="col-md-6">
                                        <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                            style="float: right">
                                            <router-link tag="a" :to="'/product-printer-proof/create'"
                                                style="float: right; margin-bottom: 10px" v-if="createPermission == true"
                                                class="btn btn-primary w-md waves-effect waves-light">
                                                {{ $t('label.createX', [$t('module.printerProof')]) }}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                                v-if="readPermission == true">
                                <template #cell(isActive)="data">
                                    <b-form-checkbox @change="editStatus(tableRows[data.index])"
                                        :disabled="updateStatusPermission == false"
                                        v-model="tableRows[data.index].isActive" switch class="mb-1">
                                    </b-form-checkbox>
                                </template>

                                <template #cell(product)="data">
                                    <span>{{ tableRows[data.index].product.name }}</span>
                                </template>

                                <template #cell(type)="data">
                                    <span v-if="tableRows[data.index].type == 0">Reply</span>
                                    <span v-if="tableRows[data.index].type == 1">Query</span>
                                </template>

                                <template #cell(action)="data">
                                    <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                        ? 'disabled text-warning'
                                        : 'text-primary'
                                        " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                        v-if="readPermission == true && updatePermission == true" title="Edit">
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>

                                    <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                        ? 'disabled text-warning'
                                        : 'text-primary'
                                        " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                        style="margin-left: 5px;"
                                        v-if="readPermission == true && updatePermission != true" title="Read">
                                        <i class="mdi mdi-file-search-outline font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div style="text-align: center;" v-else>
                                {{ $t('message.noPermissionMessage') }}
                            </div>
                        </div>
                        <div class="row" v-if="readPermission == true">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                                            @change="pageNavigation"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
a.disabled {
    pointer-events: none;
    cursor: default;
}
</style>